import React from 'react';

import { Fade, Paper, Box } from '@material-ui/core';

import { ChartDataPoint } from '@vyce/core/src/types';
import { FormSummaryQuestionTitle } from './FormSummaryQuestionTitle';
import { FormSummaryBarChart } from './FormSummaryBarChart';

interface Props {
  title: string;
  answers: ChartDataPoint[];
  totalAnswers: number;
  description?: string;
  videoLink?: string;
  photoUrl?: string;
  explanation?: string;
  pdfUrl?: string;
  onItemClick?: (answerValue: string, answerLabel: string) => void;
}

export const FormSummaryScale: React.FC<Props> = ({
  title,
  answers,
  totalAnswers,
  description,
  videoLink,
  photoUrl,
  explanation,
  pdfUrl,
  onItemClick,
}) => {
  return (
    <Fade in={true} timeout={200} style={{ width: '100%' }}>
      <Paper variant="outlined" style={{ padding: 24, width: '100%' }}>
        <FormSummaryQuestionTitle
          title={title}
          totalAnswers={totalAnswers}
          description={description}
          videoLink={videoLink}
          photoUrl={photoUrl}
          explanation={explanation}
          pdfUrl={pdfUrl}
        />

        <Box maxHeight={320}>
          <FormSummaryBarChart data={answers} layout="vertical" onItemClick={onItemClick} />
        </Box>
      </Paper>
    </Fade>
  );
};
